  <template>
  <div class="wrapper" v-observe-visibility="visibilityChanged">
    <!-- Top panel -->
    <div class="line-info" :class="{ 'is-active': product.discount_percentage }">
      <!-- Discount -->
      <div v-if="product.discount_percentage && !onlyImage" class="line-info-discount">
        <span class="line-info-discount-text"> -{{ product.discount_percentage }}% </span>
      </div>
      <!---->
      <!-- Add to cart -->
      <mini-add-to-cart v-if="isCheckoutAllowed && activeButtonAddToCart && showButtonQty" :product="product" :key="product.sku" />
    </div>
    <!---->
    <router-link :to="productLink" class="product no-underline">
      <!-- Product image -->
      <div class="product-image">
        <product-image-slider v-if="currentPartner && currentPartner.display_mode === 'shop'" class="product-image-content"
                              :image="thumbnailObj" :key="product.sku" :alt="product.name | htmlDecode"
                              data-testid="productImage" :width="imageWidth" :height="imageHeight" :index="idx" :slidesPerView="slidesPerView"

        />
        <product-image v-else :image="thumbnailObj" :key="product.sku"
                       :alt="product.name | htmlDecode" data-testid="productImage" :index="idx" :slidesPerView="slidesPerView"
        />
      </div>
      <!---->

      <!-- Product details -->
      <div class="product-details">

        <!-- Main price -->
        <div class="product-details-price">
          <price :product="product" :qty="1" />
        </div>
        <!---->

        <!-- Product naming -->
        <div class="product-details-title">
          <p class="product-details-title-text"> {{ product.name | htmlDecode }} </p>
        </div>
        <!---->

        <!-- Product size -->
        <div class="product-details-size weight" v-if="product.weight">
          <span class="product-details-size-text"> {{ product.weight | toWeight }} </span>
        </div>
        <!---->

      </div>
      <!---->

    </router-link>
  </div>
</template>

<script>
import { ProductTile } from '@vue-storefront/core/modules/catalog/components/ProductTile'
import rootStore from '@vue-storefront/core/store'
import ProductImageSlider from 'theme/components/core/ProductImageSlider'
import MiniOpenConfigurator from 'theme/components/core/MiniOpenConfigurator'
import ProductImage from 'theme/components/core/ProductImage'
import MiniAddToCart from 'theme/components/core/blocks/Shop/Product/MiniAddToCart'
import * as types from '@vue-storefront/core/modules/catalog/store/product/mutation-types'
import config from 'config'
import { mapGetters, mapMutations } from 'vuex'
import Price from 'theme/components/core/blocks/Product/Price'

function _defaultOptionValue (co) {
  switch (co.type) {
    case 'select': return co.values && co.values.length ? co.values[0].option_type_id : 0
    case 'radio': return co.values && co.values.length ? co.values[0].option_type_id : 0
    case 'checkbox':
      if (co.is_require) {
        return co.values && co.values.length ? co.values[0].option_type_id : 0
      }
      return false
    default: return ''
  }
}

function _fieldName (co) {
  return 'customOption_' + co.option_id
}

export default {
  mixins: [ProductTile],
  components: {
    ProductImageSlider,
    MiniOpenConfigurator,
    ProductImage,
    MiniAddToCart,
    Price
  },
  props: {
    labelsActive: {
      type: Boolean,
      default: true
    },
    onlyImage: {
      type: Boolean,
      default: false
    },
    idx: {
      type: Number,
      default: 0
    },
    slidesPerView: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      isActiveDesc: false,
      flagDescriptions: false,
      singleOptionProduct: null,
      showButtonQty: false
    }
  },
  beforeMount () {
    this.$bus.$on('product-after-priceupdate', this.onProductPriceUpdate)
    this.$nextTick(() => {
      this.showButtonQty = true
    })
  },
  mounted () {
    if (this.$refs.descriptions !== undefined) {
      this.flagDescriptions = this.$refs.descriptions.offsetHeight >= 170
    }
    this.$bus.$on('product-after-customoptions', this.onAfterCustomOptionsChanged)
    if (this.product.custom_options && this.product.custom_options.length === 1 && this.product.custom_options.filter(option => option.is_active === 1).length) {
      this.singleOptionProduct = this.product
      this.setupInputFields()
    }
  },
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner'
    }),
    thumbnailObj () {
      return {
        src: this.thumbnail,
        loading: this.placeholder
      }
    },
    cartItem () {
      return this.$store.getters['cart/getCartItems'].find(item => item.entity_id === this.product.entity_id)
    },
    qtyInCart () {
      if (this.cartItem) {
        return this.cartItem.qty
      }
    },
    activeButtonAddToCart () {
      return this.currentPartner.active !== undefined && this.currentPartner.enabled
    },
    isCheckoutAllowed () {
      return (this.currentLocation.hasOwnProperty('is_checkout_allowed')) ? this.currentLocation.is_checkout_allowed : true
    },
    getActionValue () {
      let discountDifference = this.product.originalPriceInclTax - this.product.price
      return Math.floor((discountDifference / this.product.originalPriceInclTax) * 100)
    },
    imageWidth () {
      return config.images.product_slider.width
    },
    imageHeight () {
      return config.images.product_slider.height
    }
  },
  methods: {
    ...mapMutations('product', {
      setCustomOptionValue: types.CATALOG_UPD_CUSTOM_OPTION
    }),
    onProductPriceUpdate (product) {
      if (product.sku === this.product.sku) {
        Object.assign(this.product, product)
      }
    },
    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        if (config.products.configurableChildrenStockPrefetchDynamic && rootStore.products.filterUnavailableVariants) {
          const skus = [this.product.sku]
          if (this.product.type_id === 'configurable' && this.product.configurable_children && this.product.configurable_children.length > 0) {
            for (const confChild of this.product.configurable_children) {
              const cachedItem = rootStore.state.stock.cache[confChild.id]
              if (typeof cachedItem === 'undefined' || cachedItem === null) {
                skus.push(confChild.sku)
              }
            }
            if (skus.length > 0) {
              rootStore.dispatch('stock/list', { skus: skus })
            }
          }
        }
      }
    },
    onAfterCustomOptionsChanged (payload) {
      let priceDelta = 0
      let priceDeltaInclTax = 0
      let optionsToProduct = []
      for (const optionValue of Object.values(payload.optionValues)) {
        optionsToProduct.push(optionValue)
        if (typeof optionValue === 'object' && parseInt(optionValue.option_type_id) > 0) {
          if (optionValue.price_type === 'fixed' && optionValue.price !== 0) {
            priceDelta += optionValue.price
            priceDeltaInclTax += optionValue.price
          }
          if (optionValue.price_type === 'percent' && optionValue.price !== 0) {
            priceDelta += ((optionValue.price / 100) * this.product.price)
            priceDeltaInclTax += ((optionValue.price / 100) * this.product.priceInclTax)
          }
        }
      }

      this.singleOptionProduct = Object.assign({}, this.product, { selected_options: optionsToProduct })
      this.singleOptionProduct.price = this.product.price + priceDelta
      this.singleOptionProduct.originalPriceInclTax = this.product.priceInclTax + priceDeltaInclTax
      this.singleOptionProduct.regular_price = this.product.priceInclTax + priceDeltaInclTax
      this.singleOptionProduct.priceInclTax = this.product.priceInclTax + priceDeltaInclTax
    },
    setupInputFields () {
      let co = this.product.custom_options[0]
      this.optionChanged(co, co.values[0])
    },
    optionChanged (option, opval) {
      const fieldName = _fieldName(option)
      const value = opval.option_type_id
      this.setCustomOptionValue({ optionId: option.option_id, optionValue: value })
      this.$store.dispatch('product/setCustomOptions', {
        product: this.product,
        customOptions: this.$store.state.product.current_custom_options
      })
      let optionValues = {}
      optionValues[fieldName] = opval
      this.onAfterCustomOptionsChanged({ product: this.product, option: option, optionValues })
    },
    onAfterRemovedVariant () {
      this.$forceUpdate()
    },
    redirectToProduct () {
      this.$router.push(this.productLink)
    }
  }
}
</script>

<style lang="scss" scoped>
  .wrapper {
    margin: 5px;
    position: relative;
    height: calc(100% - 10px);
  }

  .line-info {
    width: calc(100% - 20px);
    margin: auto;

    position: absolute;
    top: 10px;
    left: 0;
    right: 0;

    display: flex;
    justify-content: flex-end;
    align-items: center;

    z-index: 2;

    &.is-active {
      justify-content: space-between;
    }

    &-discount {
      width: 32px;
      height: 32px;

      display: flex;
      justify-content: center;
      align-items: center;

      background: #e02124;
      border-radius: 50%;

      &-text {
        color: #fff;
        font-size: 10px;
        font-weight: 600;
      }
    }
  }

  .product {
    height: 100%;
    padding: 10px;
    box-sizing: border-box;

    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    border: 1px solid #fff;
    border-radius: 5px;
    box-shadow: 0 0 4px 2px rgba(0, 0, 0, .08);

    z-index: 1;

    &:hover {
      & .product-image-content {
        transform: scale(.9);
      }
    }

    &-image {
      width: 100%;
      height: 173px;
      flex: 0 0 173px;
      z-index: -1;

      &-content {
        width: 100%;
        height: 100%;

        display: flex;
        justify-content: center;
        align-items: center;

        transition: .2s;
      }
    }

    &-details {
      margin-top: 10px;
      flex: 1 0 auto;

      &-title {
        width: 100%;
        height: 60px;

        margin: 10px 0;
        overflow: hidden;

        &-text {
          margin: 0;

          display: -webkit-box;
          /* autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */

          color: #0f0f0f;
          font-size: 14px;
          font-weight: 300;
          line-height: 20px;
          -webkit-line-clamp: 3;
        }
      }

      &-size {

        &-text {
          color: #111;
          font-size: 14px;
          font-weight: 100;

          opacity: .5;
        }
      }
    }
  }

.weight {
  font-size: 16px;
  color: #666;
}
</style>
<style lang="scss">
.product {
  &-details {
    &-price {
      .price {
        > div {
          flex-direction: column;
          row-gap: unset;

          .price-original {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
